import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchagentmarkup,
  fetchfranchiseecomm,
  selectCurrentUser,
} from "./authSlice";
import { toast } from "react-hot-toast";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Commission() {
  const {
    franchiseecomm,
    franchiseecommstatus,
  } = useSelector((state) => state.auth);
  const [loading, setloading] = useState(false);
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const [ChildData, setChildData] = useState([]);
  const [OfflineDiscount, setOfflineDiscount] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    if (user.UserData.user.UserType === 6) {
      dispatch(fetchfranchiseecomm());
    }
  }, [dispatch]);

  useEffect(() => {
    if (franchiseecommstatus === 'success') {
      setOfflineDiscount(franchiseecomm?.OfflineDiscount);
      setChildData(
        franchiseecomm?.ChildData.map(item => ({
          Category: item.category,
          markup: {
            flight: {
              domestic: item.markup.flight.domestic ?? { type: "", share: "" },
              international: item.markup.flight.international ?? { type: "", share: "" }
            },
            hotel: {
              domestic: item.markup.hotel.domestic ?? { type: "", share: "" },
              international: item.markup.hotel.international ?? { type: "", share: "" }
            },
            package: {
              domestic: item.markup.package.domestic ?? { type: "", share: "" },
              international: item.markup.package.international ?? { type: "", share: "" }
            }
          }
        }))
      );
    }
  }, [franchiseecomm, franchiseecommstatus]);

  return (
    <>

      <div className="max-w-6xl mx-auto p-4 bg-white shadow rounded-lg mt-4">

        {user.UserData.user.UserType === 6 && (
          <div className="bg-white rounded-lg overflow-hidden mb-4">
            <div className="flex items-start justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Franchisee Commission</h3>
            </div>
            {franchiseecommstatus === "pendig" && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
                  <h2 className="text-lg font-semibold mb-4">Please wait....</h2>
                  <div className="mt-6 flex flex-col items-center justify-center">
                    <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                  </div>
                </div>
              </div>
            )}
            <div className="overflow-x-auto">
              <table className="min-w-full border  text-sm">
                <thead className="bg-gray-100 text-gray-700">
                  <tr>
                    <th className="px-3 py-2 border text-left" style={{ width: "180px" }}>Category</th>

                    <th className="px-3 py-2 border text-left" colSpan="2" className="text-center">Flight</th>
                    <th className="px-3 py-2 border text-left" colSpan="2" className="text-center">Hotel</th>
                    <th className="px-3 py-2 border text-left" colSpan="2" className="text-center">Package</th>
                  </tr>

                  {/* <tr>
                    <th></th>
                    <th className="px-3 py-2 border text-left">Comm. Type</th>
                    <th className="px-3 py-2 border text-left">Fran. Share %</th>

                    <th className="px-3 py-2 border text-left">Comm. Type</th>
                    <th className="px-3 py-2 border text-left">Fran. Share %</th>

                    <th className="px-3 py-2 border text-left">Comm. Type</th>
                    <th className="px-3 py-2 border text-left">Fran. Share %</th>
                  </tr> */}
                </thead>

                <tbody>
                  {ChildData.map((row, rowIndex) => (
                    <tr key={rowIndex} className="border-b">
                      <td className=" px-3 py-2 border font-weight-bold">
                        {row.Category}
                      </td>

                      {['flight', 'hotel', 'package'].map(service => (
                        <React.Fragment key={service}>

                          {/* DOMESTIC */}
                          <td className="align-middle px-3 py-2 border">
                            <div><small>Domestic</small></div>
                            {row.markup[service].domestic.share || 0} {row.markup[service].domestic.type === 1 ? '%' : 'Fixed'} on Total
                          </td>

                          {/* INTERNATIONAL */}
                          <td className="align-middle px-3 py-2 border">
                            <div><small>International</small></div>
                            {row.markup[service].international.share || 0} {row.markup[service].international.type === 1 ? '%' : 'Fixed'} on Total
                          </td>

                        </React.Fragment>
                      ))}

                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        )}


        <div className="bg-white rounded-lg overflow-hidden mb-4">
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-800">GoerScanner Discounts & Commission</h3>
          </div>
          {franchiseecommstatus === "pendig" && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
                <h2 className="text-lg font-semibold mb-4">Please wait....</h2>
                <div className="mt-6 flex flex-col items-center justify-center">
                  <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                </div>
              </div>
            </div>
          )}
          <div className="overflow-x-auto">
            <table className="min-w-full border  text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-3 py-2 border text-left">Sectors</th>
                  <th className="px-3 py-2 border text-left" className="text-left">Block Airlines Code</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-3 py-2 border">
                    {OfflineDiscount.Sectors === 0 ? 'All Sectore' : 'Specefic Sector'}
                  </td>
                  <td className="px-3 py-2 border">
                    {(() => {
                      try {
                        return OfflineDiscount?.BlockedAirlines
                          ? JSON.parse(OfflineDiscount.BlockedAirlines).join(", ")
                          : "";
                      } catch {
                        return "";
                      }
                    })()}
                  </td>
                </tr>
              </tbody>

            </table>
            <table className="min-w-full border  text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-3 py-2 border text-left" colSpan={2}>Price Range</th>
                  <th className="px-3 py-2 border text-left" className="text-left">Discount Type</th>
                  <th className="px-3 py-2 border text-left" className="text-left">Discount Amount</th>
                  <th className="px-3 py-2 border text-left" className="text-left">Commission(Fixed)</th>
                </tr>
              </thead>

              <tbody>
                {OfflineDiscount?.child?.length > 0 && OfflineDiscount?.child.map((item, key) => (
                  <React.Fragment key={key}>
                    <tr key={key}>
                      <td className="px-3 py-2 border">
                        {item.from_price}
                      </td>
                      <td className="px-3 py-2 border">
                        {item.to_price}
                      </td>
                      <td className="px-3 py-2 border">
                        {item.discount_type === 0 ? 'Fixed' : 'Percentage'}
                      </td>
                      <td className="px-3 py-2 border">
                        {item.discount}
                      </td>
                      <td className="px-3 py-2 border">
                        {item.commission}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>

            </table>
          </div>
        </div>

      </div>
    </>
  );
}
